// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_check_your_inbox_at__email__for_the_sign_in_link_1 = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check your inbox at ${i?.email} for the sign-in link.`)
};

const en_us2_check_your_inbox_at__email__for_the_sign_in_link_1 = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check your inbox at ${i?.email} for the sign-in link.`)
};

const de_de2_check_your_inbox_at__email__for_the_sign_in_link_1 = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prüfe dein Postfach unter ${i?.email} auf den Anmelde-Link.`)
};

const en_check_your_inbox_at__email__for_the_sign_in_link_1 = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check your inbox at ${i?.email} for the sign-in link.`)
};

const de_check_your_inbox_at__email__for_the_sign_in_link_1 = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prüfe dein Postfach unter ${i?.email} auf den Anmelde-Link.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ email: NonNullable<unknown> }} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const check_your_inbox_at__email__for_the_sign_in_link_1 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.check_your_inbox_at__email__for_the_sign_in_link_1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("check_your_inbox_at__email__for_the_sign_in_link_1", locale)
	if (locale === "en-GB") return en_gb2_check_your_inbox_at__email__for_the_sign_in_link_1(inputs)
	if (locale === "en-US") return en_us2_check_your_inbox_at__email__for_the_sign_in_link_1(inputs)
	if (locale === "de-DE") return de_de2_check_your_inbox_at__email__for_the_sign_in_link_1(inputs)
	if (locale === "en") return en_check_your_inbox_at__email__for_the_sign_in_link_1(inputs)
	return de_check_your_inbox_at__email__for_the_sign_in_link_1(inputs)
};
export { check_your_inbox_at__email__for_the_sign_in_link_1 as "Check your inbox at {email} for the sign-in link." }